import { Catalog } from "@a2ui/web_core/v0_9";
import { basicCatalog } from "@a2ui/react/v0_9";
import { MetricCard } from "./MetricCard";
import { TrendChart, BreakdownChart } from "./Charts";
import { DataTable } from "./DataTable";

// The real @a2ui/react (v0.9) API has no "standardCatalog" object to spread
// and no catalog prop on a provider. A Catalog is a class instance built
// from an array of component implementations, and it is selected per-surface
// by matching its `id` string against the `catalogId` a `createSurface`
// message names (see MessageProcessor.processCreateSurfaceMessage, which
// does `this.catalogs.find(c => c.id === catalogId)`).
//
// IMPORTANT for the backend team: every `createSurface` message for this
// page MUST set `catalogId` to exactly this string, or the surface will
// fail to create (MessageProcessor throws "Catalog not found").
export const ANALYTICS_CHAT_CATALOG_ID =
  "https://mangoe.com/a2ui/catalogs/analytics-chat/v1.json";

export const analyticsChatCatalog = new Catalog(
  ANALYTICS_CHAT_CATALOG_ID,
  [
    // Spread the basic catalog's components (Text, Column, Row, Card, ...)
    // so narrative/layout wrapping still works, then layer our 4 trimmed
    // components on top.
    ...basicCatalog.components.values(),
    MetricCard,
    TrendChart,
    BreakdownChart,
    DataTable,
  ],
  [...basicCatalog.functions.values()]
);
